import { getServiceUrl } from "../api";
import RequestService from "../httpRequest";

export default {
  // 登录
  login(loginForm, callback, failCallback) {
    RequestService.sendRequest()
      .url(`${getServiceUrl()}/user/login`)
      .method("POST")
      .data(loginForm)
      .success((res) => {
        RequestService.clearRequestTime();
        callback(res);
      })
      .fail((err) => {
        RequestService.clearRequestTime();
        failCallback(err);
      })
      .networkFail(() => {
        RequestService.reAjaxFun(() => {
          this.login(loginForm, callback);
        });
      })
      .send();
  },
  // 手机验证码登录
  mobileLogin(loginForm, callback, failCallback) {
    RequestService.sendRequest()
      .url(`${getServiceUrl()}/user/mobile-login`)
      .method("POST")
      .data(loginForm)
      .success((res) => {
        RequestService.clearRequestTime();
        callback(res);
      })
      .fail((err) => {
        RequestService.clearRequestTime();
        failCallback(err);
      })
      .networkFail(() => {
        RequestService.reAjaxFun(() => {
          this.mobileLogin(loginForm, callback, failCallback);
        });
      })
      .send();
  },

  // 获取验证码
  getCaptcha(uuid, callback) {
    RequestService.sendRequest()
      .url(`${getServiceUrl()}/user/captcha?uuid=${uuid}`)
      .method("GET")
      .type("blob")
      .header({
        "Content-Type": "image/png",
        Pragma: "No-cache",
        "Cache-Control": "no-cache",
      })
      .success((res) => {
        RequestService.clearRequestTime();
        callback(res);
      })
      .networkFail((err) => {
        // 添加错误参数
      })
      .send();
  },
  // 发送短信验证码
  sendSmsVerification(data, callback, failCallback) {
    RequestService.sendRequest()
      .url(`${getServiceUrl()}/user/smsVerification`)
      .method("POST")
      .data(data)
      .success((res) => {
        RequestService.clearRequestTime();
        callback(res);
      })
      .fail((err) => {
        RequestService.clearRequestTime();
        failCallback(err);
      })
      .networkFail(() => {
        RequestService.reAjaxFun(() => {
          this.sendSmsVerification(data, callback, failCallback);
        });
      })
      .send();
  },
  // 手机验证码注册
  mobileRegister(registerForm, callback, failCallback) {
    RequestService.sendRequest()
      .url(`${getServiceUrl()}/user/mobile-register`)
      .method("POST")
      .data(registerForm)
      .success((res) => {
        RequestService.clearRequestTime();
        callback(res);
      })
      .fail((err) => {
        RequestService.clearRequestTime();
        failCallback(err);
      })
      .networkFail(() => {
        RequestService.reAjaxFun(() => {
          this.mobileRegister(registerForm, callback, failCallback);
        });
      })
      .send();
  },

  // 按用户名发送找回密码短信验证码
  sendSmsVerificationByUsername(data, callback, failCallback) {
    RequestService.sendRequest()
      .url(`${getServiceUrl()}/user/smsVerificationByUsername`)
      .method("POST")
      .data(data)
      .success((res) => {
        RequestService.clearRequestTime();
        callback(res);
      })
      .fail((err) => {
        RequestService.clearRequestTime();
        failCallback(err);
      })
      .networkFail(() => {
        RequestService.reAjaxFun(() => {
          this.sendSmsVerificationByUsername(data, callback, failCallback);
        });
      })
      .send();
  },

  // 注册账号
  register(registerForm, callback, failCallback) {
    RequestService.sendRequest()
      .url(`${getServiceUrl()}/user/register`)
      .method("POST")
      .data(registerForm)
      .success((res) => {
        RequestService.clearRequestTime();
        callback(res);
      })
      .fail((err) => {
        RequestService.clearRequestTime();
        failCallback(err);
      })
      .networkFail(() => {
        RequestService.reAjaxFun(() => {
          this.register(registerForm, callback, failCallback);
        });
      })
      .send();
  },
  // 保存设备配置
  saveDeviceConfig(device_id, configData, callback) {
    RequestService.sendRequest()
      .url(`${getServiceUrl()}/user/configDevice/${device_id}`)
      .method("PUT")
      .data(configData)
      .success((res) => {
        RequestService.clearRequestTime();
        callback(res);
      })
      .networkFail((err) => {
        console.error("保存配置失败:", err);
        RequestService.reAjaxFun(() => {
          this.saveDeviceConfig(device_id, configData, callback);
        });
      })
      .send();
  },
  // 用户信息获取
  getUserInfo(callback) {
    RequestService.sendRequest()
      .url(`${getServiceUrl()}/user/info`)
      .method("GET")
      .success((res) => {
        RequestService.clearRequestTime();
        callback(res);
      })
      .networkFail((err) => {
        console.error("接口请求失败:", err);
        RequestService.reAjaxFun(() => {
          this.getUserInfo(callback);
        });
      })
      .send();
  },

  /**
   * 已登录：校验图形验证码后向绑定手机号发送「设置登录密码」短信
   */
  sendSmsVerificationSetPassword(data, callback, failCallback) {
    RequestService.sendRequest()
      .url(`${getServiceUrl()}/user/sms-verification-set-password`)
      .method("POST")
      .data(data)
      .success((res) => {
        RequestService.clearRequestTime();
        callback(res);
      })
      .fail((err) => {
        RequestService.clearRequestTime();
        failCallback && failCallback(err);
      })
      .networkFail(() => {
        RequestService.reAjaxFun(() => {
          this.sendSmsVerificationSetPassword(data, callback, failCallback);
        });
      })
      .send();
  },

  /**
   * 已登录：短信验证通过后设置登录密码（无需旧密码）
   */
  setLoginPasswordBySms(data, callback, failCallback) {
    RequestService.sendRequest()
      .url(`${getServiceUrl()}/user/set-login-password`)
      .method("PUT")
      .data(data)
      .success((res) => {
        RequestService.clearRequestTime();
        callback(res);
      })
      .fail((err) => {
        RequestService.clearRequestTime();
        failCallback && failCallback(err);
      })
      .networkFail(() => {
        RequestService.reAjaxFun(() => {
          this.setLoginPasswordBySms(data, callback, failCallback);
        });
      })
      .send();
  },
  // 修改用户密码
  changePassword(oldPassword, newPassword, successCallback, errorCallback) {
    RequestService.sendRequest()
      .url(`${getServiceUrl()}/user/change-password`)
      .method("PUT")
      .data({
        password: oldPassword,
        newPassword: newPassword,
      })
      .success((res) => {
        RequestService.clearRequestTime();
        successCallback(res);
      })
      .networkFail((error) => {
        RequestService.reAjaxFun(() => {
          this.changePassword(
            oldPassword,
            newPassword,
            successCallback,
            errorCallback,
          );
        });
      })
      .send();
  },
  // 修改用户状态
  changeUserStatus(status, userIds, successCallback) {
    console.log(555, userIds);
    RequestService.sendRequest()
      .url(`${getServiceUrl()}/admin/users/changeStatus/${status}`)
      .method("put")
      .data(userIds)
      .success((res) => {
        RequestService.clearRequestTime();
        successCallback(res);
      })
      .networkFail((err) => {
        console.error("修改用户状态失败:", err);
        RequestService.reAjaxFun(() => {
          this.changeUserStatus(status, userIds);
        });
      })
      .send();
  },
  // 获取公共配置
  getPubConfig(callback, failCallback) {
    RequestService.sendRequest()
      .url(`${getServiceUrl()}/user/pub-config`)
      .method("GET")
      .success((res) => {
        RequestService.clearRequestTime();
        callback(res);
      })
      .fail((err) => {
        RequestService.clearRequestTime();
        if (failCallback) {
          failCallback(err);
        }
      })
      .networkFail((err) => {
        console.error("获取公共配置失败:", err);
        RequestService.reAjaxFun(() => {
          this.getPubConfig(callback, failCallback);
        });
      })
      .send();
  },
  // 找回用户密码
  retrievePassword(passwordData, callback, failCallback) {
    RequestService.sendRequest()
      .url(`${getServiceUrl()}/user/retrieve-password`)
      .method("PUT")
      .data({
        phone: passwordData.phone,
        code: passwordData.code,
        password: passwordData.password,
        captchaId: passwordData.captchaId,
      })
      .success((res) => {
        RequestService.clearRequestTime();
        callback(res);
      })
      .fail((err) => {
        RequestService.clearRequestTime();
        failCallback(err);
      })
      .networkFail(() => {
        RequestService.reAjaxFun(() => {
          this.retrievePassword(passwordData, callback, failCallback);
        });
      })
      .send();
  },
};
